import { Box, Stack, SystemProps, Text } from "@storyofams/react-ui";
import Link from "next/link";
import { getLinkProps } from "~lib";
import useMediaQuery from "~hooks/useMediaQuery";
type JobsProps = {
  content: {
    title: string;
    jobs: {
      badge?: string;
      link?: {
        url: string;
      };
      payment?: string;
      title?: string;
      type?: string;
      _uid: string;
    }[];
  };
} & SystemProps;
export const Jobs = ({ content }: JobsProps) => {
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  return (
    <Box
      width={"100%"}
      id="jobs"
      css={{
        "scroll-margin-top": matchesMobile ? "50px" : "130px",
      }}
    >
      <Text
        fontFamily={"DINPro"}
        fontWeight={700}
        fontSize={"40px"}
        lineHeight={"48px"}
        mb={5}
        textAlign={"center"}
      >
        {content.title}
      </Text>
      {content?.jobs &&
        !!content?.jobs?.length &&
        content.jobs.map((item, i) => (
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={["start", "center"]}
            border={"1px solid #E2DFDF"}
            borderRadius={"7px"}
            height={["100%", "74px"]}
            px={2}
            py={[2, 0]}
            key={item?._uid}
            mt={i && 1}
            flexDirection={["column", "row"]}
          >
            <Box
              height={"17px"}
              css={{ textTransform: "uppercase" }}
              px={"6px"}
              backgroundColor={"#EEE3D7"}
              borderRadius={"4px"}
              pt="2px"
              display={["block", "none"]}
              mr={[0, 3]}
              mb={1}
            >
              <Text fontSize={"10px"} fontWeight={700} letterSpacing={"0.1em"}>
                {item?.badge}
              </Text>
            </Box>
            <Link href={item?.link?.url} target="_blank">
              <Text
                cursor={"pointer"}
                fontWeight={[600, 700]}
                lineHeight={["25.2px", "26px"]}
                fontSize={["18px", "20px"]}
                mb={[1, 0]}
                width={"100%"}
              >
                {item?.title}
              </Text>
            </Link>

            <Box
              display={"flex"}
              alignItems={["start", "center"]}
              justifyContent={"end"}
              flexDirection={["column", "row"]}
              width={"100%"}
            >
              <Box
                height={"17px"}
                css={{ textTransform: "uppercase" }}
                px={"6px"}
                backgroundColor={"#EEE3D7"}
                borderRadius={"4px"}
                pt="2px"
                display={["none", "block"]}
                mr={[0, 3]}
              >
                <Text
                  fontSize={"10px"}
                  fontWeight={700}
                  letterSpacing={"0.1em"}
                >
                  {item?.badge}
                </Text>
              </Box>

              <Stack
                alignItems={"center"}
                mr={[0, 3]}
                fontFamily={"DINPro"}
                fontWeight={500}
                fontSize={"12px"}
                space={1}
                css={{ textTransform: "uppercase" }}
                mb={[2, 0]}
              >
                <Text>{`${item?.payment}`}</Text>
                <Text>|</Text>
                <Text>{item?.type}</Text>
              </Stack>
              <Box
                cursor={"pointer"}
                height={"42px"}
                backgroundColor={"#1D1D1B"}
                textAlign={"center"}
                as="a"
                target="_blank"
                href={getLinkProps(item.link)}
                fontWeight={500}
                fontSize={2}
                color="white"
                width={["100%", "max-content"]}
                borderRadius={"6px"}
                py={"10px"}
                px={2}
              >
                View Details
              </Box>
            </Box>
          </Box>
        ))}
    </Box>
  );
};
